<div>
  @if (chatUserInfo()) {
    <app-chat
      [appId]="chatUserInfo()!.appId"
      [currentUserName]="chatUserInfo()!.chatUserName"
      [currentUserId]="chatUserInfo()!.chatUserId"
      [conversationId]="chatUserInfo()!.conversationId"
      conversationSubject="Project Team Discussion"
      currentUserRole="customer"
    />
  }
</div>
